"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _ApiKeys = _interopRequireDefault(require("../../components/Settings/ApiKeys"));
var _ApiKeyListContainer = _interopRequireDefault(require("../../components/ApiKeysSidePaneComponents/ApiKeyList/ApiKeyListContainer"));
var _config = _interopRequireDefault(require("../../config"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./ApiKeysLayout.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var layoutClasses = (0, _cssClassesHelper.getBEMClasses)('api-keys-layout');
var ApiKeysLayout = function ApiKeysLayout() {
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('description-container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('header')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('header-title')
  }, t('About API Keys')), /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('header-text')
  }, t('The Public API is available in HTTP, WebSocket, and Get Request, with streaming data on products, product pairs, ticker activity, trades, and the order book.')), /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('header-text')
  }, t("The Private API is accessible only by registered users and enables access and control of a user's account. All key user functions may be executed from the API, including account and order management activities."))), /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('actions')
  }, /*#__PURE__*/_react["default"].createElement(_ApiKeys["default"], null), /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('documentation')
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: _config["default"].ApiKeys.documentationLink,
    target: "blank"
  }, t('View: API Documentation »'))))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('table-header')
  }, t('Existing API Keys')), /*#__PURE__*/_react["default"].createElement(_ApiKeyListContainer["default"], {
    customClass: 'retail-api-key-list'
  })));
};
var _default = exports["default"] = ApiKeysLayout;